import translation from 'locales/translation';
import { Fragment, useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography } from '@material-ui/core';
import PageTitle from 'components/__SHARED__/PageTitle/PageTitle';
import PrivateContainer from 'components/__SHARED__/PrivateContainer';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';

import { associadoActionListarProximosEventos } from 'store/modules/associado/actions';
import { IReducer } from 'store/Reducer';

import ErrorHandler from 'helpers/utils/ErrorHandler';

import CartaoEvento from '../components/CartaoEvento';
import useStyle from './styles';

export default function ProximosEventos() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { setDisableNavDrawer, disableNavDrawer } = useContext(LayoutContext);
  const { proximosEventos, proximosEventosIsLoading } = useSelector(
    (state: IReducer) => state.associado
  );

  const carregarLista = useCallback(() => {
    if (!proximosEventos && !proximosEventosIsLoading) {
      dispatch(associadoActionListarProximosEventos(undefined, ErrorHandler));
    }
  }, [dispatch, proximosEventos, proximosEventosIsLoading]);

  useEffect(() => {
    carregarLista();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !disableNavDrawer && setDisableNavDrawer(true);
    return () => {
      disableNavDrawer && setDisableNavDrawer(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableNavDrawer]);

  return (
    <PrivateContainer
      headerClassName={classes.header}
      header={
        <Fragment>
          <PageTitle title={translation.ProximosEventos.title} />
          <Typography className={classes.subtitle}>
            {translation.ProximosEventos.subtitle}
          </Typography>
        </Fragment>
      }
    >
      <Grid container spacing={4}>
        {(proximosEventos || []).map((evento) => (
          <Grid item key={evento.idEvento} xs={12} sm={6} lg={4}>
            <CartaoEvento
              coop={evento.nomeCoop}
              date={evento.dataEvento}
              idEvento={evento.idEvento.toString()}
              nome={evento.tituloEvento}
              tipo={evento.tipoEvento}
            />
          </Grid>
        ))}
      </Grid>
      {proximosEventosIsLoading && <Loading />}
    </PrivateContainer>
  );
}
